import Modal from "react-bootstrap/Modal";
import { useState } from "react";
import SrvButton from "../../../components/global/SrvButton";
import axios from "axios";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ErrorAdd from "../../../util/ErrorAdd";

function ParameterModalArchiveCancel({ show, onHide, onHideLabel, idItem, name }) {

    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(false);

    function removeHandler() {
        setLoading(true);

        axios.post('/api_tracker/parameter/updateStatus', { ID_Parameter: idItem, ID_Status: 1 })
            .then((res) => {
                if (res.data.Status === 1) {
                    setLoading(false);
                    onHide();
                    onHideLabel();
                }
                else {
                    setLog(res.data.Error);
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoading(false);
                ErrorAdd(err, window.location.href);
            });
    }

    return (
        <>
            <Modal show={show} onHide={onHide}>
                <Modal.Body>
                    <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                    <div className="modal_title text-center mb-20">Отмена архивирования параметра</div>
                    <div className="row" >
                        <div className="col-md-12 fs-5 text-center">
                            Подтвердите отмену архивирования параметра <br></br>
                            <b>«{name}»</b>
                        </div>
                    </div>
                    {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                    <div className="row mt-15">
                        <div className="col-md-12 text-center">
                            <SrvButton typeBtn="cancel" loading={loading} size={'lg'} onClick={() => removeHandler()} />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}
export default ParameterModalArchiveCancel;
